<template lang="html">
  <div>
    <div class="flex flex-row">
      <div class="w-1/4 pr-2.5">
        <input
          class="bg-input text-sm text-gray-500 outline-none px-3 py-2 w-full rounded placeholder-gray-400"
          v-model="first_name"
          placeholder="Search by First Name"
          @keyup.enter="filters"
        />
      </div>
      <div class="w-1/4 pr-2.5">
        <input
          class="bg-input text-sm text-gray-500 outline-none px-3 py-2 w-full rounded placeholder-gray-400"
          v-model="last_name"
          placeholder="Search by Last Name"
          @keyup.enter="filters"
        />
      </div>
      <div class="w-1/4 pr-2.5">
        <input
          class="bg-input text-sm text-gray-500 outline-none px-3 py-2 w-full rounded placeholder-gray-400"
          v-model="teacher_email"
          placeholder="Search Teacher by Email"
          @keyup.enter="filters"
        />
      </div>
      <div class="w-1/4">
        <pl-select
          :options="parlay_account"
          :selected="selected_connectedType"
          :arrow="true"
          placeholder="Existing / Nonexisting"
          @change="filterTeachersByConnection($event)"
          class="bg-input text-sm text-gray-500"
          style="border: none; border-radius: 5px"
        >
        </pl-select>
      </div>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  export default {
    components: {
      Multiselect,
    },
    data() {
      return {
        first_name: null,
        last_name: null,
        teacher_email: null,
        parlay_account: ['All', 'Existing', 'Nonexisting'],
        selected_connectedType: 'Existing / Nonexisting',
        parlay_account_aux: undefined,
      };
    },
    props: {
      teachersFilters: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      filters() {
        const filters = {
          first_name: this.first_name,
          last_name: this.last_name,
          teacher_email: this.teacher_email,
          parlay_account:
            this.parlay_account_aux !== undefined
              ? this.parlay_account_aux
              : '',
        };

        this.$emit('admin-portal-filter-changed');
        this.$emit('filters', filters);
      },
      filterTeachersByConnection(event) {
        this.selected_connectedType = event.toLowerCase();

        if (this.selected_connectedType === 'existing') {
          this.parlay_account_aux = true;
        } else if (this.selected_connectedType === 'nonexisting') {
          this.parlay_account_aux = false;
        } else {
          this.parlay_account_aux = undefined;
        }

        const filters = {
          first_name: this.first_name,
          last_name: this.last_name,
          teacher_email: this.teacher_email,
          parlay_account:
            this.parlay_account_aux !== undefined
              ? this.parlay_account_aux
              : '',
        };

        this.$emit('admin-portal-filter-changed');
        this.$emit('filters', filters);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .custom-select
    height: 40px
    padding 0px !important
    border: 2px solid #e1e8ee
    border-top-left-radius: 10px
    border-top-right-radius: 10px
    border-bottom-left-radius: 10px
    border-bottom-right-radius: 10px
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect {
    .multiselect__content-wrapper {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// integrationsTeachersFiltersBar.vue?61ab95b3